import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import useAddEmployee from '@/hooks/employee/useAddEmployee';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import Spinner from '@/components/Spinner';
import { PasswordInput } from '@/components/ui/password-input';
import RolesDropdown from '@/components/RolesDropdown';
import { RoleBasedComponent } from '@/utils/RoleBasedComponent';

type PropsAddEmployee = {
  onAddEmployee: () => void;
};

const AddEmployee: React.FC<PropsAddEmployee> = ({ onAddEmployee }) => {
  const [open, setOpen] = useState(false);
  const { isSubmitting, addEmployeeForm, onSubmit } = useAddEmployee();

  const handleSubmit = async (values: EmployeeToAdd) => {
    try {
      await onSubmit(
        values,
        (message) => {
          toast.success(message);
          setOpen(false);
          onAddEmployee();
        },
        (message) => toast.error(message)
      );
    } catch (error) {
      console.error('Submission error:', error); // Log any errors
    }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className='px-20 py-2 bg-primary text-white text-[16px] font-medium gap-3 rounded-md text-primary-foreground hover:bg-primary/90'>
        Add Employee
      </DialogTrigger>
      <DialogContent className='md:max-w-sm p-8'>
        <DialogHeader>
          <DialogTitle className='font-medium text-[18px]'>
            Add Employee
          </DialogTitle>
          <DialogDescription>
            <Form {...addEmployeeForm}>
              <form
                onSubmit={addEmployeeForm.handleSubmit(handleSubmit)}
                className='flex flex-col mt-4 gap-4 h-full text-black'
              >
                <FormField
                  control={addEmployeeForm.control}
                  name='fullname'
                  rules={{ required: 'Name is required' }}
                  render={({ field }) => (
                    <FormItem className=''>
                      <FormControl>
                        <Input placeholder='Name' {...field} />
                      </FormControl>

                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={addEmployeeForm.control}
                  name='email'
                  rules={{ required: 'Email is required' }}
                  render={({ field }) => (
                    <FormItem className=''>
                      <FormControl>
                        <Input type='email' placeholder='Email' {...field} />
                      </FormControl>

                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={addEmployeeForm.control}
                  name='password'
                  rules={{
                    required: 'Password is required',
                    minLength: {
                      value: 8,
                      message: 'Password must be at least 8 characters long',
                    },
                  }}
                  render={({ field }) => (
                    <FormItem className=''>
                      <FormControl>
                        {/* <Input placeholder='***********'  /> */}
                        <PasswordInput
                          {...field}
                          className='h-12'
                          placeholder='**********'
                        />
                      </FormControl>

                      <FormMessage />
                    </FormItem>
                  )}
                />

                <div className='flex gap-4 '>
                  <div>
                    <div className='bg-white h-[44px] text-muted-foreground text-sm flex justify-center items-center gap-1 border border-muted-foreground rounded-md px-4'>
                      <img src='/assets/images/algeria.svg' alt='' />
                      (+213)
                    </div>
                  </div>
                  <FormField
                    control={addEmployeeForm.control}
                    name='phone'
                    rules={{
                      required: 'Phone is required',
                      pattern: {
                        value: /^[0-9]+$/,
                        message: 'Enter a valid phone number',
                      },
                    }}
                    render={({ field }) => (
                      <FormItem className='w-[80%]'>
                        <FormControl>
                          <Input
                            type='number'
                            placeholder='07 77777777'
                            {...field}
                          />
                        </FormControl>

                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>

                <RoleBasedComponent allowedRoles={['admin']}>
                  <FormField
                    control={addEmployeeForm.control}
                    name='role'
                    rules={{
                      required: 'Roles selection is required',
                    }}
                    render={({ field }) => (
                      <FormItem>
                        <FormControl>
                          {/* <Input placeholder='***********'  /> */}
                          <RolesDropdown
                            onValueChange={field.onChange}
                            value={field.value}
                          />
                        </FormControl>

                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </RoleBasedComponent>

                <DialogFooter className='mt-4 w-full'>
                  <Button
                    disabled={isSubmitting}
                    className='px-20 w-full'
                    type='submit'
                  >
                    {isSubmitting ? <Spinner /> : <p>Save</p>}
                  </Button>
                </DialogFooter>
              </form>
            </Form>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default AddEmployee;
